import React from 'react';
import { generateFormattedDate } from './assets/generateFormattedDate';
import { Badge } from 'reactstrap';
import { FaRobot } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import {
  Image,
  ImageContent,
  MessageContent,
  MessageText,
  UserContent,
  UserName,
  UserTimestamp
} from './components/styled';
import './style.css';
import { AudioChatBallon } from 'components/Conversation/ChatBallons/styled';
import { AudioContent } from 'components/Conversation/ChatBallons/components/styled';
import { FileMessageBallon } from 'components/Conversation/ChatBallons/components/FileMessage/FileMessage';

const UserMessage = ({
  message = '',
  time = '',
  name = '',
  type = 'text',
  options = '',
  source = '',
  isAutomatic = false
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <UserContent color={systemConfiguration.primary_color}>
      <UserName>
        {name}
        {isAutomatic ? (
          <FaRobot
            style={{ display: 'block', marginLeft: '.25rem' }}
            title="Mensagem automática"
          />
        ) : null}
        :
      </UserName>
      <MessageContent>
        <MessageText>
          {(message && options) ||
            (message &&
              (type === 'link' ? (
                <u onClick={() => window.open(message, '_blank')}>{message}</u>
              ) : (
                message
              ))) ||
            options}

          {type === 'file' && (
            <FileMessageBallon source={source} description="Clique aqui" />
          )}
        </MessageText>
        {options && (
          <Badge
            className="user-option"
            color="light"
            title={`Opção da ${name}`}
          >
            Opção
          </Badge>
        )}
        {type === 'image' && (
          <ImageContent>
            <Image
              src={source}
              alt={`imagem de ${name}`}
              onClick={() => window.open(source, '_blank')}
            />
          </ImageContent>
        )}
        {type === 'audio' && (
          <AudioContent>
            <AudioChatBallon src={source} controls={true} autoPlay={false} />
          </AudioContent>
        )}
        {type === 'video' && (
          <ImageContent>
            <video
              src={source}
              autoPlay={false}
              controls={true}
              width="100%"
              height="300"
            />
          </ImageContent>
        )}
      </MessageContent>

      <UserTimestamp>{time && generateFormattedDate(time)}</UserTimestamp>
    </UserContent>
  );
};

export default UserMessage;
